import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { selectBuildingById } from '../../../../reducers/buildingSelectorReducer'

import PmsIntegration from './PmsIntegration'
import { KeylessIntegrations } from './keyless-integrations'

const OrganisationIntegration = ({ selectedBuilding }) => {
  if (!selectedBuilding) return null

  return (
    <div className="organisation-integration">
      <PmsIntegration selectedBuilding={selectedBuilding} />
      <KeylessIntegrations buildingId={selectedBuilding.id} />
    </div>
  )
}

OrganisationIntegration.propTypes = {
  params: PropTypes.object,
  selectedBuilding: PropTypes.object,
}

export default connect((state, { params }) => ({
  selectedBuilding: selectBuildingById(state)(params.buildingId),
}))(OrganisationIntegration)
